import styled from "styled-components";

export const FooterContainer = styled("div")(({ isHomePage }) => ({
  marginTop: 60,
  paddingBottom: 60,
  backgroundColor: "#FFFCF9",
  bottom: 0,
  width: "100%",
  textAlign: "center",
  p: {
    fontSize: 14,
  },

  ".logo": {
    display: "flex",
    flex: "33.33%",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  ".copywright": {
    marginTop: "2.8rem",
    width: "100%",
  },
  ".footer_title": {
    marginTop: "4rem",
    fontSize: "1.875rem",
    lineHeight: "2.375rem",
  },

  ".footer_description": {
    fontWeight: 300,
    opacity: 0.8,
    textAlign: "center",
    fontSize: "1rem",
    fontFamily: "Outfit",
    lineHeight: "1.4rem",
  },
  ".copyright_stack": {
    marginBottom: "4rem",
  },

  ".copyright": {
    marginTop: "3rem",
  },

  ".copywright_text": {
    fontSize: "0.875rem",
    fontFamily: "Outfit",
    fontWeight: 300,
    lineHeight: "1.225rem",
  },
  ".get_in_touch": {
    color: "#363636",
    textAlign: "center",
    fontSize: "1rem",
    fontFamily: "Outfit",
    fontWeight: 300,
    lineHeight: "1.4rem",
    opacity: "0.800000011920929",
  },

  "@media (max-width:768px)": {
    ".desktop_logo": {
      //   display: "none",
      textAlign: "center",
      alignItems: "center !important",
    },
    ".copywright": {
      marginTop: "0rem",
    },
    paddingTop: 20,
    paddingBottom: 30,
    ".logo": {
      textAlign: "left",
      alignItems: "flex-start",
    },
    ".footer_description": {
      fontSize: "0.8rem",
      textAlign: "left",
    },
    ".footer_title": {
      marginTop: "0.8rem",
      fontSize: "1.2rem",
      lineHeight: "2.375rem",
      textAlign: "left",
    },

    ".get_in_touch": {
      fontSize: "0.8rem",
      textAlign: "left",
      display: "none",
    },
    ".whatsapp_icon_desktop": {
      height: "30px",
      width: "30px",
      display: "none",
    },
    ".email_icon_desktop": {
      height: "30px",
      width: "30px",
      display: "none",
    },
    ".whatsapp_icon": {
      height: "20px",
      width: "20px",
    },
    ".email_icon": {
      height: "20px",
      width: "20px",
    },
    ".copywright_text": {
      fontSize: "0.67rem",
    },
  },
}));

export const FooterSocialIContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
  cursor: "pointer",

  ".get_in_touch": {
    color: "#363636",
    textAlign: "center",
    fontSize: "1rem",
    fontFamily: "Outfit",
    fontWeight: 300,
    lineHeight: "1.4rem",
    opacity: "0.800000011920929",
  },

  "@media (max-width:768px)": {
    ".get_in_touch": {
      fontSize: "0.8rem",
    },
  },
});
